import React from "react";

export default function FAQ() {
    return (
        <div className="min-h-screen bg-white px-6 md:px-20 py-20">
            <h1 className="font-display text-4xl mb-8">Frequently Asked Questions</h1>

            <div className="max-w-3xl text-sm text-gray-600 space-y-6 font-sans">

                <div>
                    <h3 className="font-semibold text-black">
                        How long does shipping take?
                    </h3>
                    <p>Orders typically arrive within 3–7 business days.</p>
                </div>

                <div>
                    <h3 className="font-semibold text-black">
                        Can I return my order?
                    </h3>
                    <p>
                        Yes. Returns are accepted within 14 days provided items are unused
                        and in original packaging.
                    </p>
                </div>

                <div>
                    <h3 className="font-semibold text-black">
                        How can I track my order?
                    </h3>
                    <p>
                        Once your order ships, you will receive a tracking number via email.
                    </p>
                </div>

            </div>
        </div>
    );
}